<mat-drawer-container autosize>
    <mat-drawer #drawer class="pt-5" mode="side" opened>
        <!-- <div class=" mt-3  pt-5">
            <strong class="mat-drawer-title font18">Organization - Groups</strong> -->
        <div class="pt-3 pl-4">
            <strong class="mattitle">{{selectedOrgNameValue}} - Groups</strong>
        </div>
        <div class="childGroupList pt-2">

            <!-- <ul> -->
            <div class="pt-3" *ngFor="let org of orgs" style="font-weight:medium;">
                <!-- <span>
                        <span class="OrgLabel font14" id="{{org.organizationId}}">
                            <i class="arrow down"></i>
                            &nbsp;&nbsp;{{org.organizationName}}
                        </span>
                    </span> -->
                <ul class="childGroupList">
                    <li style="font-weight:small;" (click)="selectGroup(grp)" *ngFor="let grp of org.groups"
                        [ngClass]="grp.groupId == group.groupId ? 'grpList span2 grpSelected':'grpList Span'">
                        <span id="{{grp.groupId}}" class="mat-subheading-2">{{grp.groupName}}</span>
                    </li>
                </ul>
            </div>
            <!-- </ul> -->
        </div>

    </mat-drawer>
    <mat-drawer-content class="">
        <div class="sidenav-content pt-5">
            <div class="mat-drawer-content-container">
                <img src="/assets/icons/Admin1.svg" height="25px" aria-label="managementLogo" alt="Admin logo" />
                <p class="mat-drawer-content-title mat-title pl-3">Admin</p>
            </div>
            <div [HideIfUnAuthorized]="'Super Admin'" class="row ml-5 firstrow" [ngClass]="{'mt-5' : loggedInUserTypeId != '1'}">
                <!-- <button mat-stroked-button color="primary" class="button-drawer"> +
                    Add a new User</button> -->
                <!-- <mat-icon class="mr-2 icon-text" title="Add a new User" (click)="addGroupUser()">
                    <img src="/assets/icons/Add New.svg" class="addIcon" />
                </mat-icon>
                <span class="sub-title ml-4 font14">Add a new User</span> -->
                <button mat-stroked-button color="primary" class="button-drawer" (click)="addGroupUser()">
                    Add New User</button>
            </div>
            <div class="row col-11 px-0 mx-5" [ngClass]="{'mt-5 pt-5' : loggedInUserTypeId != '1','mt-3' : loggedInUserTypeId == '1'}">
                <!-- <div class="entityDet-title">
                    <div class="col-2">
                       
                    </div>
                    <div class="col-10">
                        <div class="row pt-2">
                            <div class="pl-3">
                                <div class="sub-title" [attr.aria-valuenow]="group.groupName">
                                    Group Name: <span class="blueCol">
                                        {{group.groupName}}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row pt-2">
                            <div class="sub-title" [attr.aria-valuenow]="group.groupDescription"
                                style="padding-left: 15px;">
                                Group Description: <span class="blueCol">
                                    {{group.groupDescription}}
                                </span>
                            </div>
                        </div>

                    </div>
                </div> -->

                <div class="entityDet-title">
                    <div class="col-2" style="margin-top: -20px;">
                        <div class="avatar-small">
                            <ng-template [ngIf]="isImagePath == true">
                                <img class="avatar-img rounded-circle" [src]="imagePath" alt="circle logo" />
                            </ng-template>
                            <ng-template [ngIf]="isImagePath == false">
                                <img src="/assets/icons/images_nologo.jpg" class="avatar-img rounded-circle" alt="no logo">
                            </ng-template>
                            <!-- <img src="/assets/icons/images_nologo.jpg" class="avatar-img rounded-circle"> -->
                            <span class="sub-title pl-3 mat-subheading-2">Logo</span>
                        </div>
                    </div>

                    <div class="col-10">
                        <div class="row">
                            <div class="col-10">
                                <div class="sub-title mat-subheading-2" [attr.aria-valuenow]="group.groupName">
                                    Group Name: <span class="blueCol mat-subheading-2">
                                        {{group.groupName}}
                                    </span>
                                </div>
                            </div>


                            <div class="col-2 d-flex justify-content-end">
                                <mat-icon class="mr-2 icon-text" title="Edit" (click)="editGroup(group)">
                                    <img class="iconzoom" src="/assets/icons/edit1.svg" alt="Edit icon" />
                                </mat-icon>
                                <mat-icon class="mr-2 icon-text" title="Delete" (click)="deleteGroup(group)">
                                    <img class="iconzoom"  src="/assets/icons/Delete1.svg" alt="Delete icon" />
                                </mat-icon>
                            </div>
                        </div>
                        <div class="row pt-3">
                            <div class="sub-title mat-subheading-2" [attr.aria-valuenow]="group.groupDescription"
                                style="padding-left: 15px;">
                                Group Description: <span class="blueCol mat-subheading-2 wordbreak">
                                    {{group.groupDescription}}
                                </span>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="row pt-2 pl-3">
                    <div class="pt-2">
                        <input id="typeahead-prevent-manual-entry" aria-label="Search User" type="text"
                            name="searchmaual" class="placeholderstyle form-control search-width"
                            name="searchUserInstance" [(ngModel)]="selectedUser" [ngbTypeahead]="searchUser"
                            [inputFormatter]="searchUserformatter" [resultFormatter]="resultUserformatter"
                            [editable]='false' #searchUserInstance placeholder="Type to search and add the user" />
                    </div>
                    <!-- <div class="pt-3 pl-1">
                        <mat-icon class="mr-2 pb-2 icon-text" title="Add User to Group" (click)="addUser()">
                            <img src="/assets/icons/Add New.svg" class="addIcon" />
                        </mat-icon>
                    </div> -->
                    <div class="pt-2 pl-2">
                        <button mat-stroked-button class="button-drawer" (click)="addUser()">
                            Add User to Group</button>
                        <!-- <span class="sub-title font14">Add User to Group</span> -->
                    </div>
                </div>
            </div>
            <form [formGroup]="searchForm">
                <mat-accordion class="row col-11 px-0 mt-3 mx-5 panelBorder" multi>
                    <mat-expansion-panel class="w-100 mat-elevation-z0" [expanded]="panelOpenState">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <p class="m-3 lightBlue mat-subheading-1">Apply search filters</p>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <!-- <div class=" "> -->
                        <div class="container pt-3">

                            <div class="row">
                                <div class="col">
                                    Name &nbsp;
                                    <mat-form-field appearance="outline">
                                        <input formControlName="name" matInput placeholder="Search by Name" aria-label="Name">
                                    </mat-form-field>
                                </div>
                                <div class="col">
                                    Email &nbsp;
                                    <mat-form-field appearance="outline">
                                        <input formControlName="email" matInput placeholder="Search by Email" aria-label="Email">
                                    </mat-form-field>
                                </div>
                                <div class="col">
                                    Role &nbsp;
                                    <mat-form-field appearance="outline" class="form-field">
                                        <mat-select formControlName="role" placeholder="Select a Role" name="role"
                                            [(ngModel)]="role">
                                            <mat-option>None</mat-option>
                                            <mat-option *ngFor="let usertype of userTypeList"
                                                [value]="usertype.userTypeId">
                                                {{usertype.userTypeDesc }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <mat-action-row class="pr-4">
                            <button mat-raised-button class="apply-button" (click)="applySearch($event)">Search</button>
                            <button mat-raised-button class="apply-button" (click)="resetSearch($event)">Reset</button>
                        </mat-action-row>
                    </mat-expansion-panel>
                </mat-accordion>
            </form>
            <div *ngIf="data != null && data.length > 0" class="row col-11 px-0 mt-3 mx-5 overflow borderRadBtm overflow-x">
                <table mat-table aria-describedby="User Table"
                    [dataSource]="dataSource | paginate: {itemsPerPage: size, currentPage: pageIndex, totalItems: data.length}"
                    (matSortChange)="announceSortChange($event)" matSort multiTemplateDataRows >

                    <ng-container matColumnDef="fullName">
                        <th mat-header-cell *matHeaderCellDef class="table-heading mat-body-2" mat-sort-header id="FullName">
                            <span class="mat-body-2-font">Name</span>
                        </th>
                        <td mat-cell *matCellDef="let element" headers="FullName Pagination GroupName"> {{element.fullName}} </td>
                    </ng-container>

                    <ng-container matColumnDef="email">
                        <th mat-header-cell *matHeaderCellDef class="table-heading mat-body-2 grpname" mat-sort-header id="Email">
                            <span class="mat-body-2-font">Email</span>
                        </th>
                        <td mat-cell *matCellDef="let element" class="grpname" headers="Email Pagination GroupName">
                            {{element.email}} </td>
                    </ng-container>

                    <ng-container matColumnDef="userTypeDesc">
                        <th mat-header-cell *matHeaderCellDef class="table-heading mat-body-2" mat-sort-header id="UserTypeDesc">
                            <span class="mat-body-2-font">Role</span>
                        </th>

                        <td mat-cell *matCellDef="let element" headers="UserTypeDesc Pagination GroupName">
                            <ng-container
                                *ngIf="editingrow===false||(selectUser!=null && selectUser.userId!=element.userId)">
                                {{element.userTypeDesc}}
                            </ng-container>

                            <ng-container *ngIf="editingrow && selectUser.userId==element.userId">
                                <mat-form-field appearance="outline" style="padding-top: 6px;">
                                    <mat-select name="role" [(ngModel)]="element.userTypeId">
                                        <mat-option *ngFor="let usertype of userTypeList" [value]="usertype.userTypeId">
                                            {{usertype.userTypeDesc }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </ng-container>
                        </td>


                    </ng-container>
                    <ng-container matColumnDef="Supervisor">
                        <th mat-header-cell *matHeaderCellDef class=" table-heading mat-body-2 action" id="Supervisor">
                            Supervisor
                        </th>
                        <td mat-cell *matCellDef="let element" class=" action" headers="Supervisor Pagination GroupName">
                            <ng-container
                                *ngIf="editingrow===false||(selectUser!=null && selectUser.userId!=element.userId)">
                                {{element.isSupervisor == true ? 'Yes' : 'No'}}
                            </ng-container>
                            <ng-container *ngIf="editingrow && selectUser.userId==element.userId">
                                <mat-form-field appearance="outline" style="padding-top: 6px; width: 40%;">
                                    <mat-select name="role" [(ngModel)]="element.isSupervisor">
                                        <mat-option [value]="true">
                                            Yes
                                        </mat-option>
                                        <mat-option [value]="false">
                                            No
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </ng-container>

                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Actions">
                        <th mat-header-cell *matHeaderCellDef class="table-heading mat-body-2 action" id="Actions">
                            Actions
                        </th>
                        <td mat-cell *matCellDef="let element; let i = index" class="action" headers="Actions Pagination GroupName">
                            <mat-icon class="mr-2 icon-grid" title="Edit" (click)="onRowEditInit(element)"
                                *ngIf="!editingrow || (selectUser && selectUser.userId !== element.userId)">
                              <img class="iconzoom"  src="/assets/icons/edit1.svg" alt="edit icon" />
                            </mat-icon>
                          
                            <mat-icon class="mr-2 icon-grid" title="Delete" (click)="deleteUser(element)"
                                *ngIf="!editingrow || (selectUser && selectUser.userId !== element.userId)">
                              <img class="iconzoom" src="/assets/icons/Delete1.svg" alt="Delete icon" />
                            </mat-icon>
                          
                            <!-- <mat-icon *ngIf="editingrow && selectUser && selectUser.userId === element.userId"
                                class="mr-2 fa fa-floppy-o gridIcon" title="Save User" aria-hidden="true"
                                (click)="onRowEditSave(element)">
                            </mat-icon> -->
                            <img *ngIf="editingrow && selectUser && selectUser.userId === element.userId" class="mr-2 fa fa-floppy-o gridIcon"
                                title="Save User" aria-hidden="true" alt="save" class="iconzoom" src="/assets/icons/save.svg" (click)="onRowEditSave(element)">
                          
                            <!-- <mat-icon *ngIf="editingrow && selectUser && selectUser.userId === element.userId"
                                style="color: red!important;padding-right: 0px;padding-left: 5px;"
                                class="mr-2 fa fa-times gridIcon" title="Cancel User Edit" aria-hidden="true"
                                (click)="onRowEditCancel(element, i)">
                            </mat-icon> -->
                            <img *ngIf="editingrow && selectUser && selectUser.userId === element.userId" class="iconzoom ml-2 fa fa-times gridIcon"
                                title="Cancel User Edit" aria-hidden="true" src="/assets/icons/cancel.svg" alt="Cancel"
                                (click)="onRowEditCancel(element, i)">
                          </td>                          
                    </ng-container>

                    <ng-container matColumnDef="header-row-first-group">
                        <th mat-header-cell *matHeaderCellDef [attr.colspan]=displayedColumns.length class="borderRad" id="GroupName">
                            <div class="row">
                                <div class=" col-10 mat-subheading-1 pt-3  heading-color">
                                    <strong [attr.aria-valuenow]="group.groupName"
                                        class="mat-subheading-1">{{group.groupName}}</strong>
                                </div>
                                <div class="col-2 pt-3">
                                </div>

                            </div>
                        </th>
                    </ng-container>

                    <ng-container matColumnDef="header-row-size-group">
                        <th mat-header-cell class="pageItems" *matHeaderCellDef [attr.colspan]=displayedColumns.length id="Pagination">
                            <div class="mat-caption">
                                Items per page:
                                <mat-select class="mat-caption" [(value)]="size" (valueChange)="paginate(pageIndex)"
                                    style="width: 50px;margin-left: 15px">
                                    <mat-option class="mat-caption" [value]="5">5</mat-option>
                                    <mat-option class="mat-caption" [value]="10">10</mat-option>
                                    <mat-option class="mat-caption" [value]="20">20</mat-option>
                                </mat-select>
                            </div>
                        </th>
                    </ng-container>
                    <tr mat-header-row class="tableHeading" *matHeaderRowDef="['header-row-first-group']; sticky: true">
                    </tr>
                    <tr mat-header-row class="pageItems" *matHeaderRowDef="['header-row-size-group']; sticky: true"></tr>
                    <tr mat-header-row class="pageItems" *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row pageItems">
                    </tr>
                </table>

                <div class="pagination1  w-100 borderRadBtm">
                    <pagination-controls (pageChange)="paginate($event)"></pagination-controls>
                </div>

            </div>


            <div *ngIf="!data.length && data.length == 0" class="row ml-5 mr-5">
                <mat-card class="row col-md-12 ml-md-0 my-3"
                 style="height: 50px; display: flex; padding: 10px;justify-content: center;">
                  <span  class="font14 lightBlue">No records found</span>
                </mat-card>        
              </div> 
            <!-- <button mat-raised-button  class="arrow-btn-style" (click)="drawer.toggle();changeArrowIcon();">
                <fa-icon *ngIf="!arrowIconToggle" [icon]="faAngleLeft" style="font-size:15px;color:#0f6bc1"></fa-icon>
                <fa-icon *ngIf="arrowIconToggle" [icon]="faAngleRight" style="font-size:15px;color:#0f6bc1"></fa-icon>
            </button> -->
            <div class="arrow-btn-style" (click)="drawer.toggle();changeArrowIcon();"
                    (keypress)="drawer.toggle();changeArrowIcon();">
                    <!-- <mat-icon *ngIf="!arrowIconToggle" class="arrowIconStyle">keyboard_arrow_left</mat-icon>
                    <mat-icon *ngIf="arrowIconToggle" class="arrowIconStyle">keyboard_arrow_right</mat-icon> -->
                    <img class="sidetoggle" *ngIf="arrowIconToggle" [src]="'assets/icons/sidetoggle.svg'" alt="Side Toggle Icon">
                    <img class="sidetoggle" *ngIf="!arrowIconToggle" [src]="'assets/icons/sidetoggle.svg'" alt="Side Toggle Icon">
            </div>
        </div>
    </mat-drawer-content>
</mat-drawer-container>
<!-- delete user from group -->
<app-modal class="deletePopup" [ngClass]="deletePopup" [modalSize]="deleteModalSize" [modalText]="deleteModalText"
    *ngIf="!hideDeletePopUp" (modalClose)="closeDelete()">
    <div class="modal-body-extended deletePopupMsg">
        <label>Are you sure you want to remove this user from group?</label>
    </div>
    <div class="modal-footer-extended" style="text-align: center;">
        <br />
        <app-button [btnText]="deleteModalbtnText" [btnStyle]="modalbtnWithText" [btnType]="modalbtnRect"
            [btnColor]="modalbtnBlue" [btnSize]="modalbtnMedium" (click)="onRowDelete()"></app-button> &nbsp;
        <app-button [btnText]="deleteModalbtncancelText" [btnStyle]="modalbtnWithText" [btnType]="modalbtnRect"
            [btnColor]="modalbtnBlue" [btnSize]="modalbtnMedium" (click)="closeDelete()"></app-button> &nbsp;
    </div>
</app-modal>
<!-- delete group -->
<app-modal class="deletePopup" [ngClass]="deletePopup" [modalSize]="deleteModalSize" [modalText]="deleteModalText"
    *ngIf="!hideDeletegrpPopUp" (modalClose)="closegrpDelete()">
    <div class="modal-body-extended deletePopupMsg">
        <label>Are you sure you want to delete this Group?</label>
    </div>
    <div class="modal-footer-extended" style="text-align: center;">
        <br />
        <app-button [btnText]="deleteModalbtnText" [btnStyle]="modalbtnWithText" [btnType]="modalbtnRect"
            [btnColor]="modalbtnBlue" [btnSize]="modalbtnMedium" (click)="confirmDelete()"></app-button> &nbsp;
        <app-button [btnText]="deleteModalbtncancelText" [btnStyle]="modalbtnWithText" [btnType]="modalbtnRect"
            [btnColor]="modalbtnBlue" [btnSize]="modalbtnMedium" (click)="closegrpDelete()"></app-button> &nbsp;
    </div>
</app-modal>